import { render, staticRenderFns } from "./ProductionGridComponent.vue?vue&type=template&id=68615d47&"
import script from "./ProductionGridComponent.vue?vue&type=script&lang=js&"
export * from "./ProductionGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports